<!-- not verify *ngIf="dataObj?.button[0].target?.type=='not_verified'"-->
{{dataObj | json}}
<!-- <div  class="bg-white mb-2 rounded p-3 not-verified verification-process position-relative">
        <div class="w-75">
            <p class="fnt-size12px text-white">{{dataObj?.heading_text}}</p>
            <span *ngIf="dataObj?.button!=null" class="cursor-pointer btn btn-sm btn-primary fnt-size12px pt-2 pb-2 pl-4 pr-4 mt-3 text-success bg-white border-0" (click)="showWebModal('verify_step1')">{{dataObj?.button?.text || dataObj?.text}}</span>
        </div>
        <img class="position-absolute" src="assets/images/grandround/verification_idcard.svg" width="88px" style="right:2px; top: 0;"/>
    </div> -->

    <!-- <div class="bg-white mb-2 rounded p-3 not-verified verification-process position-relative">
            <div class="w-75">
                <p class="fnt-size12px text-white">{{dataObj?.heading_text}}</p>
                <span *ngIf="dataObj?.button!=null" class="cursor-pointer btn btn-sm btn-primary fnt-size12px pt-2 pb-2 pl-4 pr-4 mt-3 text-success bg-white border-0" (click)="showWebModal('verify_step1')">{{dataObj?.button?.text || dataObj?.text}}</span>
            </div>
            <img class="position-absolute" src="assets/images/grandround/verification_idcard.svg" width="88px" style="right:2px; top: 0;"/>
        </div> -->  
        <app-not-verified [dataObj]="dataObj"></app-not-verified>
        
<!--  end not verify -->